module.exports = __webpack_public_path__ + "static/media/logo_comacchio.0c809a87.webp";